import type { Router } from 'next/router';
import { useEffect } from 'react';
import { isLocalDevelopment } from '@/helpers/environment';
import { getMultilanguagePrefixBySiteName } from '@/cms/multilanguagePrefixHelper';
import type { SiteName } from '@/scopes/common/domain/types';

// Multilanguage sites '/_next/data' calls workaround
// For sites like sunweb belgium, that are in fr_BE and nl_BE we encountered that calls to static data was laking the multilanguage prefix
// Tried to solve it by next.js config basePath but encountered that other url also incorrectly changed
// https://github.com/vercel/next.js/discussions/25681#discussioncomment-2026813
export const useInterceptNextDataHref = ({ router, siteName }: { router: Router; siteName: SiteName }) => {
  useEffect(() => {
    const prefix = getMultilanguagePrefixBySiteName(siteName);
    if (!prefix || isLocalDevelopment()) {
      return;
    }

    if (router.pageLoader?.getDataHref) {
      // eslint-disable-next-line @typescript-eslint/unbound-method -- yes
      const originalGetDataHref = router.pageLoader.getDataHref;
      // eslint-disable-next-line func-names -- yes
      router.pageLoader.getDataHref = function (...args: unknown[]) {
        // @ts-expect-error -- yes
        const r = originalGetDataHref.call(router.pageLoader, ...args);
        return r && r.startsWith('/_next/data') ? `/${prefix}${r}` : r;
      };
    }
  }, [router, siteName]);
};
